import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {BranchesRoutingModule} from './branches-routing.module';
import {BranchesComponent} from './branches.component';
import {AddBranchesComponent} from './add-branches/add-branches.component';
import {ContentHeaderModule} from '../../layout/components/content-header/content-header.module';
import {TranslateModule} from '@ngx-translate/core';
import {CoreCommonModule} from '../../../@core/common.module';
import {CardSnippetModule} from '../../../@core/components/card-snippet/card-snippet.module';
import {NgxDatatableModule} from '@swimlane/ngx-datatable';
import {CoreSidebarModule} from '../../../@core/components';
import {NgbPaginationModule} from '@ng-bootstrap/ng-bootstrap';


@NgModule({
    declarations: [BranchesComponent, AddBranchesComponent],
    imports: [
        CommonModule,
        BranchesRoutingModule,
        ContentHeaderModule,
        TranslateModule,
        CoreCommonModule,
        CardSnippetModule,
        NgxDatatableModule,
        CoreSidebarModule,
        NgbPaginationModule
    ],
    exports: [BranchesComponent, AddBranchesComponent]
})
export class BranchesModule {
}
